export const CASHBACK_BRANDS = [
  { key: 'BOT', title: 'Cashback BOT' },
  { key: 'EUD', title: 'Cashback EUD' },
  { key: 'QDB', title: 'Cashback QDB' }
] as const

export type CashbackBrandKey = (typeof CASHBACK_BRANDS)[number]['key']
